var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup392(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 91,
    viewBox: "0 0 98 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.7795 91C75.7197 91 97.559 88.7251 97.559 85.9189C97.559 83.1126 75.7197 80.8376 48.7795 80.8376C21.8393 80.8376 0 83.1126 0 85.9189C0 88.7251 21.8393 91 48.7795 91Z",
    fill: "#9D9D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8901 69.3803L68.2501 74.9003C74.2201 76.3103 80.2001 72.6203 81.6101 66.6503L92.3601 21.1803C93.7701 15.2103 90.0801 9.2303 84.1101 7.8203L60.7501 2.30028C54.7801 0.89028 48.8001 4.58028 47.3901 10.5503L36.6401 56.0203C35.2301 61.9903 38.9201 67.9703 44.8901 69.3803Z",
    fill: "white",
    stroke: "#09314C",
    strokeWidth: 3.0039,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1391 12.8603L62.0391 8.58032",
    stroke: "#09314C",
    strokeWidth: 3.0039,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3916 57.7903H11.7115C8.89155 57.7903 6.60156 55.5003 6.60156 52.6803V24.5303C6.60156 21.7103 8.89155 19.4203 11.7115 19.4203H59.3916C62.2116 19.4203 64.5016 21.7103 64.5016 24.5303V52.6803C64.5016 55.5003 62.2116 57.7903 59.3916 57.7903Z",
    fill: "#AACA11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5507 50.0803C31.9607 50.0803 28.3807 48.7103 25.6407 45.9803L6.60066 26.8203C6.53066 24.9303 6.50066 23.3903 7.03066 22.4703L28.0607 43.5603C32.1907 47.6903 38.9107 47.6903 43.0407 43.5603L64.1307 22.6103C64.5207 23.5803 64.6207 25.0703 64.5007 26.9403L45.4606 45.9803C42.7206 48.7203 39.1407 50.0803 35.5507 50.0803Z",
    fill: "#09314C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 65.0002H20.13",
    stroke: "#AACA11",
    strokeWidth: 3.0039,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14062 12.8604H11.0606",
    stroke: "#AACA11",
    strokeWidth: 3.0039,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup392);
export default __webpack_public_path__ + "static/media/Group 392.a45aaeb6d6389c9cd1710d20ff472dd8.svg";
export { ForwardRef as ReactComponent };